import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ContentCrmObjectContext } from 'ContentEditorUI/components/publishing/ContentCrmObjectProvider';
import { markStagedPageSettingsSeeded, setStagedPageData
// @ts-ignore not yet migrated
} from 'page-editor-ui/redux/actions/stagedPageActions';
// @ts-ignore untyped module
import { seedStagedPageSettings } from 'ContentEditorUI/redux/actions/baseContentModelActions';
const useStagedPageReduxSync = () => {
  var _context$isStagingV;
  const dispatch = useDispatch();
  const context = useContext(ContentCrmObjectContext);
  const isStagingV2 = (_context$isStagingV = context === null || context === void 0 ? void 0 : context.isStagingV2) !== null && _context$isStagingV !== void 0 ? _context$isStagingV : false;
  const stagedPageSandboxDomain = context === null || context === void 0 ? void 0 : context.stagedPageSandboxDomain;
  const stagedPageStatus = context === null || context === void 0 ? void 0 : context.stagedPageStatus;
  const stagedPagePreviewUrl = context === null || context === void 0 ? void 0 : context.stagedPagePreviewUrl;
  const stagedPageName = context === null || context === void 0 ? void 0 : context.stagedPageName;
  const stagedPageSlug = context === null || context === void 0 ? void 0 : context.stagedPageSlug;
  const stagedPageHtmlTitle = context === null || context === void 0 ? void 0 : context.stagedPageHtmlTitle;
  const stagedPageDomainName = context === null || context === void 0 ? void 0 : context.stagedPageDomainName;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const seeded = useSelector(state => state.stagedPage.seeded);
  useEffect(() => {
    dispatch(setStagedPageData({
      sandboxDomainName: isStagingV2 ? stagedPageSandboxDomain || null : null,
      liveDomainName: isStagingV2 ? stagedPageDomainName || null : null,
      status: isStagingV2 ? stagedPageStatus || null : null,
      previewUrl: isStagingV2 ? stagedPagePreviewUrl || null : null
    }));
  }, [dispatch, isStagingV2, stagedPageSandboxDomain, stagedPageDomainName, stagedPageStatus, stagedPagePreviewUrl]);
  useEffect(() => {
    if (isStagingV2 && !seeded && stagedPageName !== undefined) {
      dispatch(markStagedPageSettingsSeeded());
      dispatch(seedStagedPageSettings({
        name: stagedPageName,
        slug: stagedPageSlug,
        htmlTitle: stagedPageHtmlTitle,
        domain: stagedPageDomainName
      }));
    }
  }, [dispatch, isStagingV2, seeded, stagedPageName, stagedPageSlug, stagedPageHtmlTitle, stagedPageDomainName]);
};
export default useStagedPageReduxSync;